export class Customer{
    name?: string;
    
    id: number =0;
    primarySalesContact!: ContactInformation;
    
    phone?: String;
    customerEmail?: String;
    
    logoUrl?: string;
    address!: Address;
    
}

export class ContactInformation {
    
    name?: string | null;
    phone?: string | null;
    designation?: string | null;
    email?: string | null;
    plant?: string | null;
    
  }

  export class Address {
    id?: number;
    street?: string | null;
    city?: string | null;
    region?: string | null;
    district?: string | null;
    state?: string | null;
    country?: string | null;
    zipcode?: number | null;
    stateCode?: number | null;
    lattitude?: number | null;
    longitude?: number | null;
  }